/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import { Repeat } from 'sushiweb/Icons';
import { AgentActionsV1 } from '../../widgets';
import { black } from 'sushiweb/tokens/color';
import { useDispatch, useSelector } from 'react-redux';
import { closeActionView } from '../../../store/basicOrder/actions';
import { Bot, CircleHelp, Layers2, ScrollText } from 'lucide-react';
import { IS_SIDEBAR_CLOSE } from '../../../store/basicOrder/reducers';
import { Icon } from '@grofers/dock-design-kit';

const dashboardMode = window.dashboard.mode;
const infoHeaderCss = {
  borderCss:
    'tw-h-11 tw-flex  tw-items-center tw-justify-center tw-px-4 tw-border-[#CFCFCF] tw-border-solid tw-border-[0.5px] tw-border tw-rounded-[8px] tw-cursor-pointer hover:tw-bg-[#F5F5F5] tw-transition-all tw-duration-300',
};
const OrderActionWidget = (props) => {
  const {
    orderId,
    userId,
    orderBasicInfo,
    openHelpSectionPopUp,
    openCallLogsModal,
    reloadOrder,
    showIssuesBox,
    showCopilotView,
  } = props;

  const actionsRef = useRef();
  const dispatch = useDispatch();

  const isActionViewClose = useSelector(
    (state) => state.basicOrderState?.isActionViewClose,
  );

  return (
    <div className='tw-flex tw-gap-3 tw-items-start tw-justify-center'>
      {/* Agent Copilot button */}
      {orderBasicInfo?.order?.is_copilot_enabled && (
        <div
          className='callsStatus tw-h-11 tw-flex tw-items-center tw-justify-center tw-px-4 tw-border-none tw-rounded-[8px] tw-cursor-pointer tw-relative tw-bg-purple-700'
          onClick={showCopilotView}
          data-dd-action-name='Agent Copilot'
        >
          <p className='tw-text-white tw-text-300 tw-font-medium tw-whitespace-nowrap tw-flex tw-items-center'>
            <Icon name='ai-1' size='md' className='!tw-text-white tw-mr-2' />{' '}
            Copilot
          </p>
        </div>
      )}

      {/* Issues and Actions for Smartplug */}
      {dashboardMode === 'smartplug' && (
        <div
          className={`callsStatus ${infoHeaderCss.borderCss} tw-relative tw-flex tw-items-center tw-justify-center`}
          onClick={showIssuesBox}
          data-dd-action-name='Open Issues and Actions'
        >
          <p className='tw-text-base-green tw-text-300 tw-font-medium tw-whitespace-nowrap'>
            <Layers2 size={14} className='tw-mr-2' strokeWidth={2.2} /> Issues &
            Actions
          </p>
        </div>
      )}

      {/* Issues and Actions for Lifeline */}
      {isActionViewClose && dashboardMode !== 'smartplug' && (
        <div
          className={`callsStatus ${infoHeaderCss.borderCss} tw-relative tw-flex tw-items-center tw-justify-center`}
          onClick={() => {
            localStorage.setItem(IS_SIDEBAR_CLOSE, 'false');
            dispatch(closeActionView(false));
          }}
          data-dd-action-name='Open Issues and Actions'
        >
          <p className='tw-text-base-green tw-text-[1.4rem] tw-font-medium tw-cursor-pointer'>
            <Layers2 size={14} className='tw-mr-2' strokeWidth={2.2} /> Issues &
            Actions
          </p>
        </div>
      )}

      <div
        className={`callsStatus ${infoHeaderCss.borderCss} tw-relative tw-flex tw-items-center tw-justify-center`}
        onClick={openCallLogsModal}
        data-dd-action-name='Open Call Logs'
      >
        <p className='tw-text-base-green tw-text-[1.4rem] tw-font-medium tw-cursor-pointer tw-whitespace-nowrap'>
          <ScrollText size={14} className='tw-mr-2' /> Call Logs
        </p>
      </div>
      <div
        className={`callsStatus ${infoHeaderCss.borderCss} tw-relative`}
        onClick={openHelpSectionPopUp}
        data-dd-action-name='Open Help Section'
      >
        <p className='tw-text-base-green tw-text-[1.4rem] tw-font-medium tw-cursor-pointer'>
          <CircleHelp size={14} className='tw-mr-2' /> Help
        </p>
      </div>
      <div
        className={
          'tw-h-11  tw-flex tw-items-center tw-justify-center tw-relative tw-cursor-pointer tw-rounded-[8px] tw-aspect-square tw-border-solid tw-border-[0.5px] tw-border-[#CFCFCF] hover:tw-bg-[#F5F5F5] tw-transition-all tw-duration-300'
        }
        onClick={reloadOrder?.bind(this, orderId)}
        data-dd-action-name='Reload Order'
      >
        <Repeat size={18} color={black} />
      </div>
      <div onClick={() => actionsRef.current?.openActionsMenu?.()}>
        <AgentActionsV1
          ref={actionsRef}
          orderId={orderId}
          userId={userId}
          orderBasicInfo={orderBasicInfo}
        />
      </div>
    </div>
  );
};

export default OrderActionWidget;
